import generate from 'nanoid/generate';
import BaseComponent from 'foundation/base-component';

class DfpBanner extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.targetId = generate('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 10);
        this.element.id = this.targetId;

        window.googletag = window.googletag || {};
        window.gptAdSlots = [];
        window.googletag.cmd = window.googletag.cmd || [];
        window.googletag.cmd.push(() => {
            const bottomAdSizes = window.googletag.sizeMapping()
                .addSize([768, 0], this.options.adUnitDesktopSize)
                .addSize([0, 0], this.options.adUnitMobileSize)
                .build();

            window.gptAdSlots[0] = window.googletag
                .defineSlot(
                    this.options.slot, [
                        this.options.adUnitMobileSize,
                        this.options.adUnitDesktopSize
                    ],
                    this.targetId
                );

            if (window.gptAdSlots[0]) {
                window.gptAdSlots[0].defineSizeMapping(bottomAdSizes)
                    .addService(window.googletag.pubads());
            }

            window.googletag.pubads().enableSingleRequest();
            window.googletag.companionAds().setRefreshUnfilledSlots(true);
            window.googletag.pubads().enableVideoAds();
            window.googletag.enableServices();

            setInterval(() => {
                window.googletag.pubads().refresh();
            }, this.options.refreshRate);
        });

        window.googletag.cmd.push(() => {
            window.googletag.display(this.targetId);
        });

        this.loadScipt();
    }

    loadScipt() {
        if (window.googletag && window.googletag.apiReady) return;

        const script = document.createElement('script');
        script.src = '//www.googletagservices.com/tag/js/gpt.js';
        script.async = true;
        document.body.appendChild(script);
    }
}

export default DfpBanner;
